import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import EngineerLayout from './EngineerLayout';
import { 
    FaArrowLeft, 
    FaSearch,
    FaSortAmountDown,
    FaCopy,
    FaFileExcel,
    FaPrint
} from 'react-icons/fa';

const EngineerSocietyApprovedApplications = () => {
    const navigate = useNavigate();
    const [department, setDepartment] = useState('विभाग प्रकार निवडा');
    const [taluka, setTaluka] = useState('तालुका निवडा');

    // Sample data from the image
    const [data] = useState([
        { id: "१", name: "हरिकृष्ण मजूर सहकारी संस्था", chairman: "श्रीम. रूपाली संभाजी गायकवाड", phone: "९८८१३९२३८८", taluka: "पुरंदर", count: "०", date: "" },
        { id: "२", name: "श्री गोसावीबाबा मजूर सहकारी संस्था", chairman: "श्री.धनंजय हरिश्चंद्र बगाटे", phone: "९७६६८७३७६८", taluka: "शिरूर", count: "०", date: "" },
        { id: "३", name: "श्री अविनाश मजूर सहकारी संस्था मर्या", chairman: "सुरज विलास काळे", phone: "८२७५८८२०८०", taluka: "दौंड", count: "०", date: "" },
        { id: "४", name: "दिलासा मजूर सहकारी संस्था", chairman: "संजय शंकर टाकळकर", phone: "७७६९०४९७९७", taluka: "खेड", count: "०", date: "" },
        { id: "५", name: "श्री मयुरेश्वर मजूर सहकारी संस्था", chairman: "शरद चंद्रकांत बारवकर", phone: "९४२३५७५०७३", taluka: "बारामती", count: "०", date: "" },
        { id: "६", name: "मजूर सहकारी संस्था", chairman: "श्रीम पुष्पलता वामनराव जाधव", phone: "९८८१३९१३०३", taluka: "आंबेगाव", count: "०", date: "" },
    ]);

    return (
        <EngineerLayout>
            <div className="p-8 bg-[#f4f7fe] min-h-screen font-hind text-left">
                {/* Header Section */}
                <div className="flex justify-between items-center mb-10 px-2 text-left">
                    <div className="flex items-center gap-6">
                        <button 
                            onClick={() => navigate('/engineer/approved-records-menu')}
                            className="p-4 bg-white rounded-2xl shadow-sm hover:bg-gray-50 transition-all text-gray-600 border border-gray-100 hover:scale-105 active:scale-95 group"
                        >
                            <FaArrowLeft size={18} className="group-hover:-translate-x-1 transition-transform" />
                        </button>
                        <h1 className="text-2xl font-black text-gray-800 tracking-tight">सोसायटीने मंजूर केलेले अर्ज</h1>
                    </div>
                    <div className="hidden md:flex items-center gap-3 text-[11px] font-black text-gray-400 bg-white px-6 py-3 rounded-2xl border border-gray-100 shadow-sm uppercase tracking-wider text-right">
                        जिल्हा परिषद / <span className="text-emerald-600">सोसायटीने मंजूर केलेले अर्ज</span>
                    </div>
                </div>

                {/* Main Content Card */}
                <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8">
                    {/* Filters Section */}
                    <div className="flex flex-wrap gap-8 items-end mb-10 ml-2">
                        <div className="space-y-3 text-left w-64">
                            <label className="text-[14px] font-black text-gray-400 tracking-tight ml-1 flex items-center gap-1">
                                विभाग <span className="text-red-500">*</span>
                            </label>
                            <select 
                                className="w-full border border-gray-200 rounded-lg px-5 py-2.5 outline-none focus:border-emerald-500 bg-white text-gray-700 font-bold transition-all appearance-none text-sm"
                                value={department}
                                onChange={(e) => setDepartment(e.target.value)}
                            >
                                <option value="विभाग प्रकार निवडा">विभाग प्रकार निवडा</option>
                                <option value="स्थापत्य">स्थापत्य</option>
                                <option value="विद्युत">विद्युत</option>
                            </select>
                        </div>
                        <div className="space-y-3 text-left w-64">
                            <label className="text-[14px] font-black text-gray-400 tracking-tight ml-1">तालुका निवडा</label>
                            <div className="flex gap-4">
                                <select 
                                    className="flex-grow border border-gray-200 rounded-lg px-5 py-2.5 outline-none focus:border-emerald-500 bg-white text-gray-700 font-bold transition-all appearance-none text-sm"
                                    value={taluka}
                                    onChange={(e) => setTaluka(e.target.value)}
                                >
                                    <option value="तालुका निवडा">तालुका निवडा</option>
                                    <option value="पुरंदर">पुरंदर</option>
                                    <option value="शिरूर">शिरूर</option>
                                    <option value="दौंड">दौंड</option>
                                    <option value="खेड">खेड</option>
                                    <option value="बारामती">बारामती</option>
                                    <option value="आंबेगाव">आंबेगाव</option>
                                </select>
                                <button className="bg-[#6366f1] hover:bg-[#4f46e5] text-white px-8 py-2.5 rounded-lg font-bold shadow-lg shadow-indigo-500/10 transition transform active:scale-95 flex items-center gap-2 uppercase tracking-wide text-sm">
                                    शोध
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Utility and Search Bar */}
                    <div className="flex justify-between items-center mb-6">
                        <div className="flex gap-1">
                            <button className="flex items-center gap-2 bg-gray-600 hover:bg-gray-700 text-white px-4 py-2 rounded font-bold text-xs transition-colors">
                                <FaCopy size={12} /> कॉपी करा
                            </button>
                            <button className="flex items-center gap-2 bg-gray-600 hover:bg-gray-700 text-white px-4 py-2 rounded font-bold text-xs transition-colors">
                                <FaFileExcel size={12} /> एक्सेल
                            </button>
                            <button className="flex items-center gap-2 bg-gray-600 hover:bg-gray-700 text-white px-4 py-2 rounded font-bold text-xs transition-colors">
                                <FaPrint size={12} /> प्रिंट
                            </button>
                        </div>
                        <div className="flex items-center gap-2">
                            <span className="text-[12px] font-black text-gray-400 uppercase tracking-widest">शोध:</span>
                            <input 
                                type="text"
                                className="border border-gray-200 rounded px-3 py-1.5 outline-none focus:border-emerald-500 text-sm font-bold w-40"
                            />
                        </div>
                    </div>

                    {/* Table Section */}
                    <div className="overflow-x-auto border border-gray-100 rounded-xl shadow-sm">
                        <table className="w-full border-collapse">
                            <thead>
                                <tr className="bg-white border-b border-gray-200 text-[12px] font-black text-gray-800 text-left">
                                    <th className="px-5 py-4 border-r border-gray-100 min-w-[60px]">
                                        <div className="flex justify-between items-center gap-2">
                                            # <FaSortAmountDown size={10} className="text-gray-300" />
                                        </div>
                                    </th>
                                    <th className="px-5 py-4 border-r border-gray-100 min-w-[300px]">
                                        <div className="flex justify-between items-center gap-2">
                                            संस्थेचे नाव <FaSortAmountDown size={10} className="text-gray-300" />
                                        </div>
                                    </th>
                                    <th className="px-5 py-4 border-r border-gray-100 min-w-[200px]">
                                        <div className="flex justify-between items-center gap-2">
                                            अध्यक्षांचे नाव <FaSortAmountDown size={10} className="text-gray-300" />
                                        </div>
                                    </th>
                                    <th className="px-5 py-4 border-r border-gray-100 min-w-[150px]">
                                        <div className="flex justify-between items-center gap-2">
                                            फोन नंबर <FaSortAmountDown size={10} className="text-gray-300" />
                                        </div>
                                    </th>
                                    <th className="px-5 py-4 border-r border-gray-100 min-w-[120px]">
                                        <div className="flex justify-between items-center gap-2">
                                            तालुका <FaSortAmountDown size={10} className="text-gray-300" />
                                        </div>
                                    </th>
                                    <th className="px-5 py-4 border-r border-gray-100 min-w-[150px]">
                                        <div className="flex justify-between items-center gap-2">
                                            कामाची संख्या <FaSortAmountDown size={10} className="text-gray-300" />
                                        </div>
                                    </th>
                                    <th className="px-5 py-4 min-w-[150px]">
                                        <div className="flex justify-between items-center gap-2">
                                            लॉटरीची तारीख <FaSortAmountDown size={10} className="text-gray-300" />
                                        </div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.map((item, index) => (
                                    <tr key={index} className="hover:bg-emerald-50/10 transition-colors border-b border-gray-50 last:border-0 text-[13px] text-gray-700 font-bold text-left">
                                        <td className="px-5 py-4 border-r border-gray-50">{item.id}</td>
                                        <td className="px-5 py-4 border-r border-gray-50">
                                            <button className="text-blue-500 hover:text-blue-700 hover:underline transition-colors decoration-2 font-bold tracking-tight text-left">
                                                {item.name}
                                            </button>
                                        </td>
                                        <td className="px-5 py-4 border-r border-gray-50 text-gray-600">{item.chairman}</td>
                                        <td className="px-5 py-4 border-r border-gray-50 font-hind">{item.phone}</td>
                                        <td className="px-5 py-4 border-r border-gray-50">{item.taluka}</td>
                                        <td className="px-5 py-4 border-r border-gray-50 font-hind">{item.count}</td>
                                        <td className="px-5 py-4 font-hind">{item.date}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Hind:wght@400;500;600;700&display=swap');
                .font-hind {
                    font-family: 'Hind', sans-serif;
                }
            `}</style>
        </EngineerLayout>
    );
};

export default EngineerSocietyApprovedApplications;
